import React, { Component, Fragment } from 'react'
import { Switch, Route } from 'react-router-dom'

import { SegmentBuilderSidebar } from '@driftt/cyberno'
import { EMPTY_SEGMENT_MODEL } from 'constants/segment'
import AccountsSegmentation from 'pages/AccountsSegmentation'

class SegmentationHome extends Component {
  state = {
    isOpen: false,
    selectedSegment: null,
    isNew: true
  }

  toggle = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
      selectedSegment: null
    }))
  }

  setSelectedSegment = segment => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
      selectedSegment: segment,
      isNew: false
    }))
  }

  setCreateNew = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
      selectedSegment: null,
      isNew: true
    }))
  }

  onSave = data => {
    this.toggle()
  }

  render() {
    const { isOpen, isNew, selectedSegment } = this.state

    return (
      <Fragment>
        <Switch>
          <Route path="/segments" render={() => (
            <AccountsSegmentation 
              toggleEditor={this.setCreateNew} 
              onSegmentSelect={this.setSelectedSegment}
              history={this.props.history}
              /> 
          )}/>
        </Switch>

        <SegmentBuilderSidebar
          isOpen={isOpen}
          hideOverlay={true}
          onSave={this.onSave}
          close={this.toggle}
          propertyTypes={['ACCOUNT']}
          outputType="ACCOUNT"
          segmentId={selectedSegment}
          segment={isNew ? EMPTY_SEGMENT_MODEL : null}
        />
      </Fragment>
    )
  }
}

export default SegmentationHome